export default __webpack_public_path__ + "static/media/kit_contrattuale_web.669cee8d.pdf";